<template>
  <PageLayout :headerText="headerText">
    <template #header-addon-left>
      <router-link :to="prevRoute" class="flex items-center p-0.5 mr-2">
        <div class="h-5 w-5 text-gray-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M15 19l-7-7 7-7" />
          </svg>
        </div>
      </router-link>
    </template>
    <template #main>
      <div v-if="workAreaId" class="flex flex-1 flex-col bg-gray-50 overflow-auto">
        <WorkAreaDetails :workAreaId="workAreaId">
          <router-view></router-view>
        </WorkAreaDetails>
      </div>
    </template>
  </PageLayout>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
import PageLayout from "@/components/PageLayout.vue";
import WorkAreaDetails from "@/features/workAreas/details/WorkAreaDetails.vue";
// store
import useWorkAreaStore from "@/store/useWorkAreaStore";
// other
import { repairUuid } from "@/utils/globalHelpers";

export default defineComponent({
  name: "WorkAreaDetailsPage",
  components: {
    PageLayout,
    WorkAreaDetails
  },
  setup() {
    // workArea id from link
    const {
      params: { workAreaId: workAreaUrlId }
    } = useRoute();
    const workAreaId = computed(() => repairUuid(workAreaUrlId));

    // get work area
    const { workArea } = useWorkAreaStore({ workAreaId: workAreaId.value });

    // get previous route, that was not workArea details related
    const prevRoute = computed(() => {
      if (window.history.state.back === null || window.history.state.back.includes("work-areas")) {
        return "/work-areas";
      } else return window.history.state.back;
    });

    const headerText = computed(() => {
      if (workArea.value) return workArea.value.name;
      else return "";
    });

    return {
      headerText,
      workAreaId,
      prevRoute
    };
  }
});
</script>
